declare namespace $ {

	export class $bog_builderui_badge extends $bog_builderui_div {
		title( ): string
		variant( ): string
		attr( ): ({ 
			'bog_builderui_badge_variant': ReturnType< $bog_builderui_badge['variant'] >,
		})  & ReturnType< $bog_builderui_div['attr'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=badge.view.tree.d.ts.map